import { Entry } from "contentful"
import { slugAndIdDelimiter } from "./extractSlugAndId"
import { TypeProductEntitySkeleton } from "../ContentfulVzdelanibudoucnostiTypes"

export const getProductSlug = (p: Entry<TypeProductEntitySkeleton, undefined, string>): string => `${p.fields.slug}${slugAndIdDelimiter}${p.sys.id}`
